var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions';
import * as OrgActions from '../../../auth/store/actions/organization.actions';
import * as UserActions from '../../../auth/store/actions/user.actions';
var initialState = {
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en-us',
};
var translation = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.CHANGE_LANG: {
            localStorage.setItem('lang', action.payload.lang);
            return __assign(__assign({}, state), { lang: action.payload.lang });
        }
        case OrgActions.SET_ORGANIZATION_DATA: {
            if (!action.payload.masterLanguage)
                return state;
            localStorage.setItem('lang', action.payload.masterLanguage);
            return __assign(__assign({}, state), { lang: action.payload.masterLanguage });
        }
        case UserActions.SET_USER_DATA: {
            if (!action.payload.settings || !action.payload.settings.preferredLanguage)
                return state;
            localStorage.setItem('lang', action.payload.settings.preferredLanguage);
            return __assign(__assign({}, state), { lang: action.payload.settings.preferredLanguage });
        }
        default: {
            return state;
        }
    }
};
export default translation;



//////////////////
// WEBPACK FOOTER
// ./src/translation/store/reducers/translation.reducer.ts
// module id = 1491
// module chunks = 81